export const HCP_WORKFLOW_STEPS = {
    hcp_info: "hcp_info",
    patient_info: "patient_info",
    schedule_call_or_skip: "schedule_call_or_skip",
    call_scheduled_refer_another_patient: "call_scheduled_refer_another_patient",
    call_skipped_refer_another_patient: "call_skipped_refer_another_patient",
};
